import AbstractRequestTask from "../AbstractRequestTask";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import { th } from "date-fns/locale";

class CheckUrlTask extends AbstractRequestTask {

  constructor(url) {
    super();
    this.url = url;
  }
  
  getUrl() {
    return `${this.url}`;
  }

  success(data, b) {
    this.resolve(data);
  }

  isValid(data) {
    return true;
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default CheckUrlTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/application/CheckUrlTask.js